module.exports = __webpack_public_path__ + "static/img/trend-2.d8c5cba6.png";